export enum CheckupAppointmentBoxStatus {
  READY,
  READY_KIOSK,
  CONNECTED_SAME_KIOSK_SAME_USER,
  CONNECTED_SAME_KIOSK_DIFFERENT_USER,
  CONNECTED_SAME_USER,
  CONNECTED_DIFFERENT_USER,
  CONNECTED_DIFFERENT_KIOSK,
}
